import { render, staticRenderFns } from "./LeaderCoVisitDetail.vue?vue&type=template&id=178ed548&scoped=true"
import script from "./LeaderCoVisitDetail.vue?vue&type=script&lang=js"
export * from "./LeaderCoVisitDetail.vue?vue&type=script&lang=js"
import style0 from "./LeaderCoVisitDetail.vue?vue&type=style&index=0&id=178ed548&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ed548",
  null
  
)

export default component.exports